import { ProviderName } from '@indigohive/cogfy-providers'

export const MAP_LOGO_BY_PROVIDER: Partial<Record<ProviderName, string>> = {
  anthropic: '/anthropic-avatar.webp',
  aws: '/awsbedrock-avatar.webp',
  azure: '/azure-avatar.webp',
  azureAd: '/azuread-avatar.webp',
  braveSearch: '/brave-search-avatar.webp',
  cloudamqp: '/cloudamqp-avatar.webp',
  deepseek: '/deepseek-avatar.webp',
  elevenLabs: '/elevenlabs-avatar.webp',
  github: '/github-avatar.webp',
  googleAIStudio: '/google-avatar.webp',
  googleCalendar: '/googlecalendar-avatar.webp',
  govbr: '/govbr-avatar.webp',
  grok: '/grok-avatar.webp',
  groq: '/groq-avatar.webp',
  hamsa: '/hamsa-avatar.webp',
  heroku: '/heroku-avatar.webp',
  huggingface: '/huggingface-avatar.webp',
  http: '/http-avatar.webp',
  infosimples: '/infosimples-avatar.webp',
  jira: '/jira-avatar.webp',
  lemonfox: '/lemonfox-avatar.webp',
  maritaca: '/maritaca-avatar.webp',
  metaMarketingApi: '/meta-avatar.webp',
  nuvemfiscal: '/nuvemfiscal-avatar.webp',
  openai: '/openai-avatar.webp',
  pinecone: '/pinecone-avatar.webp',
  postgresql: '/postgresql-avatar.webp',
  rdStation: '/rdstation-avatar.webp',
  sendgrid: '/sendgrid-avatar.webp',
  sentry: '/sentry-avatar.webp',
  serper: '/serper-avatar.webp',
  slack: '/slack-avatar.webp',
  stripe: '/stripe-avatar.webp',
  twilio: '/twilio-avatar.webp',
  typesense: '/typesense-avatar.webp',
  unstructured: '/unstructured-avatar.webp',
  vindi: '/vindi-avatar.webp',
  webflow: '/webflow-avatar.webp',
  whatsapp: '/whatsapp-avatar.webp'
}

export const MAP_LOGO_BY_MODULE: Partial<Record<string, string>> = {
  ...MAP_LOGO_BY_PROVIDER,
  googlecalendar: '/googlecalendar-avatar.webp',
  elevenlabs: '/elevenlabs-avatar.webp',
  bravesearch: '/brave-search-avatar.webp'
}
